<template>
  <div id="cotacao-resposta" class="cotacao">
    <div class="row m-0" v-if="!checkIsEmpty(cotacao)">
      <div class="col-12">
        <h1 class="title font-weight-bold text-uppercase">
          Orçamento Recebido
        </h1>
        <hr class="linha-amarela" />
      </div>
      <div class="card-cotacao">
        <div class="px-2">
          <div class="cc-header d-flex">
            <div class="cc-sub-title m-r-25">
              <img
                class="imagem-archive-cotacao"
                src="@/assets/img/icons/file-archive.png"
                alt="Ícone para representar o Orçamento"
              />
            </div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Data:
                <div class="cc-sub-result" v-if="cotacao[0].criado_em !== null">
                  {{ cotacao[0].criado_em }}
                </div>
              </div>
            </div>
            <div class="cc-sub-line"></div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Cód:
                <div class="cc-sub-result" v-if="cotacao[0].id !== null">
                  {{ cotacao[0].id }}
                </div>
              </div>
            </div>
            <div class="cc-sub-line"></div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Preferência:
                <div class="cc-sub-result" v-if="preferencia !== null">
                  {{ preferencia }}
                </div>
              </div>
            </div>
          </div>
          <div class="cc-content p-0">
            <div class="table" v-if="this.cotacao[0].produtos.length > 0">
              <h4 class="mt-3">Inseridos pelo cliente</h4>
              <table class="table">
                <tbody>
                  <tr
                    v-for="(produto, index) in this.cotacao[0].produtos"
                    :key="index"
                  >
                    <div class="item-header mt-2">
                      <!-- Numero -->
                      <td
                        class="row subIds letter-orange fs-24 m-auto bg-light"
                        v-bind:class="[
                          produto.disponivel == true ? '' : ' red-font',
                        ]"
                      >
                        {{ index + 1 + 'º ITEM' }}
                      </td>

                      <div class="row px-3">
                        <!-- Produto NOME -->
                        <td
                          class="col-md-10"
                          v-bind:class="
                            'td' +
                            [produto.disponivel == true ? '' : ' red-font']
                          "
                          v-if="produto.produto"
                        >
                          <span class="letter-orange text-uppercase">NOME</span>
                          <br />
                          <p class="mt-2">
                            {{ produto.produto.nome }}
                          </p>
                        </td>
                        <td
                          class="col-md-10"
                          v-else
                          v-bind:class="
                            'td' +
                            [produto.disponivel == true ? '' : ' red-font']
                          "
                        >
                          <span class="letter-orange text-uppercase">NOME</span>
                          <br />
                          <p class="mt-2">
                            {{ produto.produto_nome }}
                          </p>
                        </td>

                        <!-- Fotos -->
                        <td class="col-md-2">
                          <span class="letter-orange text-uppercase"
                            >Fotos</span
                          >
                          <div v-if="produto.foto !== null">
                            <img
                              class="img-small c-pointer"
                              :src="`${getImagesAddress}` + produto.foto"
                              @click="showZoom(produto.foto)"
                              v-if="produto.foto !== null"
                            />
                          </div>
                          <div v-else>Sem foto</div>
                        </td>
                      </div>
                    </div>
                    <!-- Fim linha 1 do Orçamento -->

                    <div class="row px-3">
                      <!-- Marca -->
                      <td
                        class="col-md-5"
                        v-if="
                          produto.marca !== null ||
                          produto.marca_nome !== null ||
                          produto.marca === null ||
                          produto.marca_nome
                        "
                        v-bind:class="
                          'td' + [produto.disponivel == true ? '' : ' red-font']
                        "
                      >
                        <span class="letter-orange text-uppercase">
                          Marca ofertada
                        </span>
                        <v-select
                          class="resize-input"
                          v-model="produto.marca"
                          label="nome"
                          :options="produtoMarcas"
                          placeholder="Escolha ou digite uma marca"
                          taggable
                        ></v-select>
                      </td>

                      <td class="col-md-6" v-if="produto.marca_nome !== null">
                        <span class="letter-orange text-uppercase">
                          Marca
                        </span>
                        {{ produto.marca_nome }}
                      </td>

                      <!-- Medida -->
                      <td
                        class="col-md-7"
                        v-bind:class="
                          'td' + [produto.disponivel == true ? '' : ' red-font']
                        "
                      >
                        <span class="letter-orange text-uppercase">
                          Medida
                        </span>
                        <div v-if="produto.medida !== null">
                          <p class="mt-2">
                            {{ produto.medida.nome }}
                          </p>
                        </div>
                        <div v-else-if="produto.medida_nome !== null">
                          <p class="mt-2">
                            {{ produto.medida_nome }}
                          </p>
                        </div>
                        <div class="px-2" v-else>Sem medida</div>
                      </td>
                    </div>
                    <!-- FIM LINHA 2 -->

                    <div class="row px-3 mt-3">
                      <!-- Quantidade -->

                      <td
                        class="col-md-2"
                        v-bind:class="
                          'td' + [produto.disponivel == true ? '' : ' red-font']
                        "
                      >
                        <span class="letter-orange text-uppercase"
                          >Quantidade</span
                        >
                        <br />
                        <p class="mt-2 p-1 ml-3">
                          {{ produto.quantidade }}
                        </p>
                      </td>

                      <!-- Preço Unitário -->
                      <td
                        v-if="tela > 768"
                        class="col-md-3"
                        v-bind:class="
                          'td' + [produto.disponivel == true ? '' : ' red-font']
                        "
                      >
                        <span class="letter-orange text-uppercase ml-4">
                          Preço Unitário<p class="d-inline text-danger">*</p>
                        </span>
                        <br />
                        <input
                          type="text"
                          class="ml-4"
                          v-bind:class="
                            'preco_unitario' +
                            [produto.disponivel == true ? '' : ' red-font']
                          "
                          v-money="money"
                          v-model="produto.preco"
                          maxlength="14"
                          @keydown="removeSpecialChars($event)"
                        />
                      </td>

                      <td
                        v-else
                        class="col-md-3"
                        v-bind:class="
                          'td' + [produto.disponivel == true ? '' : ' red-font']
                        "
                      >
                        <span class="letter-orange text-uppercase">
                          Preço Unitário
                        </span>
                        <br />
                        <input
                          type="text"
                          v-bind:class="
                            'preco_unitario' +
                            [produto.disponivel == true ? '' : ' red-font']
                          "
                          v-money="money"
                          v-model="produto.preco"
                          maxlength="14"
                          @keydown="removeSpecialChars($event)"
                        />
                      </td>

                      <!-- Subtotal -->
                      <td
                        class="col-md-3"
                        v-bind:class="
                          'td' + [produto.disponivel == true ? '' : ' red-font']
                        "
                      >
                        <span class="letter-orange text-uppercase"
                          >Subtotal</span
                        >
                        <br />
                        <input
                          type="text"
                          v-bind:class="
                            'preco_unitario' +
                            [produto.disponivel == true ? '' : ' red-font']
                          "
                          v-money="money"
                          :value="subValor(produto.preco, produto.quantidade)"
                          readonly
                        />
                      </td>

                      <!-- Dúvidas -->
                      <td class="col-md-2 td">
                        <span class="letter-orange text-uppercase"
                          >Dúvidas</span
                        >
                        <div class="btn-message" @click="abrirCaixa(index)">
                          <i class="fas fa-envelope"></i>
                        </div>
                      </td>

                      <!-- Disponível -->
                      <td
                        class="col-md-2"
                        v-bind:class="
                          'td' + [produto.disponivel == true ? '' : ' red-font']
                        "
                      >
                        <span class="letter-orange text-uppercase"
                          >Disponível</span
                        >
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="'disponivel' + index"
                            v-model="produto.disponivel"
                          />
                          <label
                            class="custom-control-label"
                            :for="'disponivel' + index"
                          >
                            <div v-if="produto.disponivel == true">Sim</div>
                            <div v-else>Não</div>
                          </label>
                        </div>
                      </td>
                    </div>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- PARA INSERIRRRRRRRRRRRRRRRRRR -->
            <div>
              <h4>Para inserir</h4>
              <table class="table">
                <tbody>
                  <tr
                    class="tr fs-14"
                    v-for="(produto, index) in this.produtos"
                    :key="index"
                  >
                    <div class="header-table">
                      <td class="subIds letter-orange fs-24 bg-light">
                        {{ index + 1 + 'º ITEM' }}
                      </td>
                    </div>

                    <!-- Nome -->

                    <td class="row fs-18 px-2">
                      <div class="col-md-12">
                        <span class="letter-orange text-uppercase size-font">
                          NOME
                        </span>
                        <v-select
                          v-model="produto.produto"
                          label="nome"
                          :options="produtosRegistrados"
                          placeholder="Digite um produto"
                          taggable
                        ></v-select>
                      </div>
                    </td>

                    <div class="row px-2 fs-18">
                      <!-- Marca -->
                      <td class="col-md-6">
                        <span class="letter-orange text-uppercase size-font">
                          Marca
                        </span>
                        <v-select
                          class="resize-input"
                          v-model="produto.marca"
                          label="nome"
                          :options="produtoMarcas"
                          placeholder="Escolha ou digite uma marca"
                          taggable
                        ></v-select>
                      </td>

                      <!-- Medida -->
                      <td class="col-md-6">
                        <span class="letter-orange text-uppercase size-font">
                          MEDIDA
                        </span>
                        <v-select
                          class="d-inline-block"
                          v-model="produto.medida"
                          label="nome"
                          :options="tipoMedidas"
                          placeholder="Digite uma medida"
                        >
                          <div slot="no-options">
                            Não temos essa opção <br />
                            no momento &#x1F62D;
                          </div>
                        </v-select>
                      </td>
                    </div>

                    <!-- Quantidade -->
                    <div class="row px-2">
                      <td class="col-md-3">
                        <span class="letter-orange text-uppercase size-font"
                          >Quantidade</span
                        >
                        <br />
                        <input
                          type="number"
                          min='0'
                          class="preco_unitario"
                          width="50px"
                          v-model="produto.quantidade"
                          onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"
                        />
                      </td>
                      <!-- Preço Unitário -->
                      <td v-if="tela > 768" class="col-md-3">
                        <span class="letter-orange text-uppercase size-font"
                          >Preço Unitário</span
                        >
                        <br />
                        <input
                          type="text"
                          class="alinhamento"
                          v-model="produto.preco"
                          v-money="money"
                          maxlength="14"
                          @keydown="removeSpecialChars($event)"
                        />
                      </td>

                      <td v-else class="col-md-3">
                        <span class="letter-orange text-uppercase size-font"
                          >Preço Unitário</span
                        >
                        <br />
                        <input
                          type="text"
                          class="preco_unitario"
                          v-model="produto.preco"
                          v-money="money"
                          maxlength="14"
                          @keydown="removeSpecialChars($event)"
                        />
                      </td>

                      <!-- Subtotal -->

                      <td class="col-md-3">
                        <span class="letter-orange text-uppercase size-font"
                          >Subtotal</span
                        >
                        <br />
                        <input
                          type="text"
                          class="preco_unitario"
                          v-money="money"
                          :value="subValor(produto.preco, produto.quantidade)"
                          readonly
                        />
                      </td>

                      <!-- Dúvidas -->
                      <td class="col-md-1">
                        <span class="letter-orange text-uppercase size-font"
                          >Dúvidas</span
                        >
                        <br />
                        <div class="btn-message" @click="abrirCaixaProd(index)">
                          <i class="fas fa-envelope"></i>
                        </div>
                      </td>

                      <!-- Apagar o produto  -->
                      <td class="col-md-2">
                        <button
                          class="btn btn-outline-danger mt-3"
                          @click="apagarProduto(index)"
                        >
                          <i class="fas fa-trash-alt"></i> Remover
                        </button>
                      </td>
                    </div>
                  </tr>
                  <tr>
                    <td colspan="9">
                      <div class="c-pointer" @click="adicionarProduto()">
                        <div class="btn-plus">
                          <i class="fas fa-plus"></i>
                        </div>
                        <div class="fs-17 d-inline-block p-left-10px">
                          Produto
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Campo de arquivo -->
            <div class="row m-0" v-if="cotacao[0].arquivo !== null">
              <div class="col-12 m-15px-0px">
                <div
                  class="d-block"
                  v-if="cotacao[0].quantidade_arquivo !== null"
                >
                  Quantidade: {{ cotacao[0].quantidade_arquivo }}
                </div>
                <div class="d-block" v-if="cotacao[0].arquivo !== null">
                  <a
                    :href="
                      `https://api.construp.com.br/storage/upload/` +
                      cotacao[0].arquivo
                    "
                    class="
                      btn btn-primary
                      c-pointer
                      fs-14
                      text-uppercase
                      bg-dark-blue
                    "
                    download
                  >
                    Baixar arquivo
                    <i class="fas fa-file-upload m-l-7px"></i>
                  </a>
                </div>
              </div>
            </div>

            <!-- Campo de imagem -->
            <div class="row m-0" v-if="cotacao[0].imagem !== null">
              <div class="col-12 m-15px-0px">
                <div class="d-block" v-if="cotacao[0].quantidade_foto !== null">
                  Quantidade: {{ cotacao[0].quantidade_foto }}
                </div>
                <DownloadImages :allImages="this.cotacao[0].imagem" />
              </div>
            </div>
          </div>

          <!-- FRETEEEEEEEEEE -->
          <div class="cc-content">
            <div class="row m-0">
              <div
                class="col-12 p-7-top p-0-left mb-2"
                v-if="checkIsEmpty(this.cotacao[0].cep)"
              >
                <b class="font-weight-bold text-uppercase fs-15"
                  >Retira na loja</b
                >
              </div>
              <div class="col-12 p-0 mb-2"
                v-if="!checkIsEmpty(this.cotacao[0].cep)"
                >
                <b class="font-weight-bold text-uppercase fs-15"
                  >CEP de entrega: {{ this.cotacao[0].cep }}</b
                >
              </div>
              <div
                class="col-md-3 p-0 mb-2"
                v-if="!checkIsEmpty(this.cotacao[0].cep)"
              >
                <b class="font-weight-bold text-uppercase fs-15">Frete:</b>
                <br />
                <input
                  type="text"
                  class="freteMargin"
                  :class="frete.class"
                  v-money="money"
                  v-model="frete.valor"
                  @keydown="removeSpecialChars($event)"
                />
              </div>
              <div>
                <b class="text-uppercase fs-15">Prazo de entrega:</b>
                <br />
                <select v-model="prazo.valor" class="form-control"
                :class="prazo.class">
                  <option value="">Quantidade de dia(s)</option>
                  <option value="1">1 dia</option>
                  <option
                    v-for="(days, index) in countDays"
                    :key="index"
                    :value="days + 1"
                  >
                    {{ days + 1 }} dias
                  </option>
                </select>
              </div>
            </div>
          </div>
          <!-- FRETEEEEEEEEEE -->

          <div class="row mt-3">
            <div class="col-md-3 prazo-entrega">
              <b class="px-2 text-uppercase fs-15">Cliente Paga:</b><br />
              <input
                type="text"
                :class="frete.class"
                v-money="money"
                :value="valorTotal + freteValor"
                readonly
              />
            </div>
            <!-- VALIDADE DE ORÇAMENTO -->

            <div class="col-sm-4 condicoes-pagamento-entrega fs-15">
              <b class="text-uppercase d-block"> Orçamento válido até:<p class="d-inline text-danger">*</p> </b>
              <input
                type="date"
                :class="orcamentodata.class"
                v-model="orcamentodata.valor"
                @change="blockPreviousDates"
              />
            </div>
          </div>

          <!-- ############################## CALCULADORA DE RECEBIMENTO ################################ -->

          <div class="item-header">
            <hr />
            <h4 class="text-center fs-24 bg-light p-3">
              CALCULADORA DE RECEBIMENTO
            </h4>
            <hr />
            <h6 class="text-center">
              Simule abaixo os valores a receber, de acordo com a forma de
              pagamento escolhida!
            </h6>
          </div>

          <!-- ############## PIX ################ -->
          <h4 class="mt-3">Pix</h4>
          <div class="row">
            <!-- Desconto -->
            <div class="col-md-2">
              <b class="text-uppercase px-2 fs-14">% Desconto:</b>
              <i
                class="fas fa-question-circle question-tool-tips"
                id="descontoPix"
              ></i>
              <b-tooltip target="descontoPix"
                >Trata-se do valor porcentual e opcional para oferecer desconto
                sobre o valor integral do orçamento</b-tooltip
              >
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-mask="['#.##', '##.##']"
                  v-model="desconto.pix"
                  maxlength="5"
                />
                <div class="input-group-append">
                  <span class="input-group-text" id="">%</span>
                </div>
              </div>
            </div>

            <!-- TAXA UP-->
            <div class="col-md">
              <b class="text-uppercase fs-14">Taxa Up: </b>
              <i
                class="fas fa-question-circle question-tool-tips"
                id="taxaUp"
              ></i>
              <b-tooltip target="taxaUp"
                >Trata-se da comissão de 4,0% sobre as vendas na plataforma
                Constr Up</b-tooltip
              >
              <div>
                <input
                  class="input-group-text"
                  style="margin: 0px; width: 90%"
                  type="text"
                  v-model="taxa.upPix"
                  readonly
                />
              </div>
            </div>

            <!-- TAXA TRANSAÇÃO-->
            <div class="col-md">
              <b class="text-uppercase fs-14">Taxa Transação:</b>
              <i
                class="fas fa-question-circle question-tool-tips"
                id="taxaTransacao"
              ></i>
              <b-tooltip target="taxaTransacao"
                >Trata-se da taxa fixa por transação (R$0,30) + 0,99% da taxa da
                plataforma de pagamento (Iugu)</b-tooltip
              >
              <div>
                <input
                  class="input-group-text"
                  style="margin: 0px; width: 90%"
                  type="text"
                  readonly
                  v-model="taxa.pix"
                />
              </div>
            </div>

            <!-- A RECEBER -->
            <div class="col-md">
              <b class="text-uppercase fs-14">Valor a receber:</b>
              <i
                class="fas fa-question-circle question-tool-tips"
                id="liquido"
              ></i>
              <b-tooltip target="liquido"
                >Trata-se do valor à receber líquido</b-tooltip
              >
              <div>
                <input
                  class="input-group-text"
                  style="margin: 0px; width: 80%"
                  type="text"
                  v-model="pixTotal"
                  readonly
                />
              </div>
            </div>
          </div>
          <hr />
          <!-- ############## FIM pix ################ -->

          <!-- ############## Boleto ################ -->
          <h4 class="mt-3">Boleto</h4>
          <div class="row">
            <!-- Desconto -->
            <div class="col-md-2">
              <b class="text-uppercase fs-14">% Desconto:</b>
              <i
                class="fas fa-question-circle question-tool-tips"
                id="descontoBoleto"
              ></i>
              <b-tooltip target="descontoBoleto"
                >Trata-se do valor porcentual e opcional para oferecer desconto
                sobre o valor integral do orçamento</b-tooltip
              >
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-mask="['#.##', '##.##']"
                  v-model="desconto.boleto"
                  maxlength="5"
                />
                <div class="input-group-append">
                  <span class="input-group-text" id="">%</span>
                </div>
              </div>
            </div>

            <!-- TAXA UP-->
            <div class="col-md">
              <b class="text-uppercase fs-14">Taxa Up:</b>
              <i
                class="fas fa-question-circle question-tool-tips"
                id="taxaUpBoleto"
              ></i>
              <b-tooltip target="taxaUpBoleto"
                >Trata-se da comissão de 4,0% sobre as vendas na plataforma
                Constr Up</b-tooltip
              >
              <div>
                <input
                  class="input-group-text"
                  style="margin: 0px; width: 90%"
                  type="text"
                  v-model="taxa.upBoleto"
                  readonly
                />
              </div>
            </div>

            <!-- TAXA BOLETO-->
            <div class="col-md">
              <b class="text-uppercase fs-14">Taxa Transação:</b>
              <i
                class="fas fa-question-circle question-tool-tips"
                id="taxaTransacaoBoleto"
              ></i>
              <b-tooltip target="taxaTransacaoBoleto"
                >Trata-se da taxa fixa por transação (R$0,30) + 1,5% da taxa da
                plataforma de pagamento (Iugu)</b-tooltip
              >
              <div>
                <input
                  class="input-group-text"
                  style="margin: 0px; width: 90%"
                  type="text"
                  v-model="taxa.boleto"
                  readonly
                />
              </div>
            </div>

            <!-- A RECEBER -->
            <div class="col-md">
              <b class="text-uppercase fs-14">Valor a receber:</b>
              <i
                class="fas fa-question-circle question-tool-tips"
                id="liquidoBoleto"
              ></i>
              <b-tooltip target="liquidoBoleto"
                >Trata-se do valor à receber líquido</b-tooltip
              >
              <div>
                <input
                  class="input-group-text"
                  style="margin: 0px; width: 80%"
                  type="text"
                  v-model="boletoTotal"
                  readonly
                />
              </div>
            </div>
          </div>
          <!-- ############## FIM boleto################ -->

          <!-- ############## PARCELADO ################ -->
          <hr />
          <h4 class="mt-3">Cartão de Credito</h4>

          <div class="row">
            <!-- SELECIONA PARCELA -->
            <div class="col-md">
              <b class="text-uppercase fs-14">Parcelas até:</b>
              <i
                class="fas fa-question-circle question-tool-tips"
                id="simulaParcelas"
              ></i>
              <b-tooltip target="simulaParcelas"
                >Trata-se no número máximo de parcelas que sua loja pretende
                disponibilizar para pagamento</b-tooltip
              >
              <select class="form-control" v-model="totalParcelas" @click="selectQtdParcelas()">
                <option value="1">1x</option>
                 <option value="2">2x</option>
                <option value="3">3x</option>
                <option value="4">4x</option>
                <option value="5">5x</option>
                <option value="6">6x</option>
                <option value="7">7x</option>
                <option value="8">8x</option>
                <option value="9">9x</option>
                <option value="10">10x</option>
                <option value="11">11x</option>
                <option value="12">12x</option>
              </select>
            </div>

            <!--TAXA UP-->
            <div class="col-md">
              <b class="text-uppercase fs-14">Taxa Up:</b>
              <i
                class="fas fa-question-circle question-tool-tips"
                id="taxaUpCartao"
              ></i>
              <b-tooltip target="taxaUpCartao"
                >Trata-se da comissão de 4,0% sobre as vendas na plataforma
                Constr Up</b-tooltip
              >
              <div>
                <input
                  class="input-group-text"
                  style="margin: 0px; width: 90%"
                  type="text"
                  v-model="taxa.upCartao"
                  readonly
                />
              </div>
            </div>

            <!-- TAXA TRANSAÇÃO-->
            <div class="col-md">
              <b class="text-uppercase fs-14">Taxa Transação:</b>
              <i
                class="fas fa-question-circle question-tool-tips"
                id="taxaTransacaoCartao"
              ></i>
              <b-tooltip target="taxaTransacaoCartao"
                >Trata-se da taxa fixa por transação (R$0,30) + 2,35% ao mês da
                taxa da plataforma de pagamento (Iugu)</b-tooltip
              >
              <div>
                <input
                  class="input-group-text"
                  style="margin: 0px; width: 90%"
                  type="text"
                  v-model="taxa.cartao"
                  readonly
                />
              </div>
            </div>

            <!-- A RECEBER -->
            <div class="col-md">
              <b class="text-uppercase fs-14">Valor a Receber:</b>
              <i
                class="fas fa-question-circle question-tool-tips"
                id="liquidoCartao"
              ></i>
              <b-tooltip target="liquidoCartao"
                >Trata-se do valor à receber líquido</b-tooltip
              >
              <div>
                <input
                  class="input-group-text"
                  style="margin: 0px; width: 90%"
                  type="text"
                  v-model="cartaoTotal"
                  readonly
                />
              </div>
            </div>

            <!-- PARCELADO -->
            <div class="col-md">
              <b class="text-uppercase fs-14">Valor Parcela:</b>
              <i
                class="fas fa-question-circle question-tool-tips"
                id="parcela"
              ></i>
              <b-tooltip target="parcela"
                >Trata-se do valor à receber mensal sem antecipação</b-tooltip
              >
              <div v-if="totalParcelas == 0">
                <input
                  class="input-group-text"
                  style="margin: 0px; width: 90%"
                  type="text"
                  v-model="cartaoTotal"
                  readonly
                />
              </div>
              <div v-else>
                <input
                  class="input-group-text"
                  style="margin: 0px; width: 90%"
                  type="text"
                  v-model="cartaoParcelado"
                  readonly
                />
              </div>
            </div>
          </div>
          <hr />
          <!-- ############## FIM PARCELADO ################ -->

          <!-- ############################## FIM CALCULADORA DE RECEBIMENTO ################################ -->

          <!-- ############################## FORMA DE PAGAMENTO ################################ -->
          <div class="item-header">
            <h4 class="text-center fs-24 bg-light p-3">FORMA DE PAGAMENTO<p class="d-inline text-danger">*</p></h4>
            <hr />
            <h6 class="text-center">
              Selecione as opções de pagamentos para seu cliente
            </h6>
          </div>

          <div class="row">
            <!-- CHECKBOX PIX-->
            <div class="col-md-3">
              <div>
                <b class="text-uppercase px-2 fs-14"></b>
                <div class="form-check custom-control custom-checkbox">
                  <input
                    id="checkboxPix"
                    class="form-check-input"
                    type="checkbox"
                    @click="formPayments('P')"
                  />
                  <label class="form-check-label"> PIX </label>
                </div>
              </div>

              <!-- Desconto Pix -->
              <div class="mt-2" style="width: 60%">
                <b class="text-uppercase px-2 fs-14">% Desconto:</b>
                <i
                  class="fas fa-question-circle question-tool-tips"
                  id="descontoPixCliente"
                ></i>
                <b-tooltip target="descontoPixCliente"
                  >Trata-se do valor porcentual e opcional para oferecer
                  desconto sobre o valor integral do orçamento</b-tooltip
                >
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-mask="['#.##', '##.##']"
                    v-model="desconto.pix"
                    maxlength="5"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text" id="">%</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- CHECKBOX BOLETO -->
            <div class="col-md-3">
              <div>
                <b class="text-uppercase px-2 fs-14"></b>
                <div class="form-check custom-control custom-checkbox">
                  <input
                    id="checkboxBoleto"
                    class="form-check-input"
                    type="checkbox"
                    @click="formPayments('B')"
                  />
                  <label for="checkbox" class="form-check-label">
                    BOLETO
                  </label>
                </div>
              </div>

              <!-- Desconto -->
              <div class="mt-2" style="width: 60%">
                <b class="text-uppercase fs-14">% Desconto:</b>
                <i
                  class="fas fa-question-circle question-tool-tips"
                  id="descontoBoletoCliente"
                ></i>
                <b-tooltip target="descontoBoletoCliente"
                  >Trata-se do valor porcentual e opcional para oferecer
                  desconto sobre o valor integral do orçamento</b-tooltip
                >
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-mask="['#.##', '##.##']"
                    v-model="desconto.boleto"
                    maxlength="5"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text" id="">%</span>
                  </div>
                </div>
              </div>
            </div>

            <!--CARTÃO-->
            <div class="col-md-3">
              <div>
                <b class="text-uppercase px-2 fs-14"></b>
                <div class="form-check custom-control custom-checkbox">
                  <input
                    id="checkboxCartao"
                    class="form-check-input"
                    type="checkbox"
                    @click="formPayments('C')"
                  />
                  <label class="form-check-label"> CARTÃO DE CREDITO </label>
                </div>

                <!-- SELECIONA PARCELA -->
                <div class="mt-2">
                  <b class="text-uppercase fs-14">Parcelas até:</b>
                  <i
                    class="fas fa-question-circle question-tool-tips"
                    id="formaParcelas"
                  ></i>
                  <b-tooltip target="formaParcelas"
                    >Trata-se no número máximo de parcelas que sua loja pretende
                    disponibilizar para pagamento</b-tooltip
                  >
                  <select
                    class="form-control"
                    v-model="totalParcelas"
                    style="width: 60%"
                    @click="selectQtdParcelas('prod')"
                  >
                    <option value="1">1x</option>
                    <option value="2">2x</option>
                    <option value="3">3x</option>
                    <option value="4">4x</option>
                    <option value="5">5x</option>
                    <option value="6">6x</option>
                    <option value="7">7x</option>
                    <option value="8">8x</option>
                    <option value="9">9x</option>
                    <option value="10">10x</option>
                    <option value="11">11x</option>
                    <option value="12">12x</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <hr />

          <!-- ############################## FIM FORMA DE PAGAMENTO ################################ -->

          <div class="cc-footer">
            <div class="position-relative p-10 linha-abaixo-cinza">
              <div class="mb-2">
                <label
                  for="txtSalesmanName"
                  class="fs-15 font-weight-bold text-uppercase"
                  >Vendedor(a):<p class="d-inline text-danger">*</p></label
                >
                <input
                  type="text"
                  :class="nome_vendedor.class"
                  id="txtSalesmanName"
                  v-model="nome_vendedor.value"
                  placeholder="Nome do Vendedor(a)"
                />
              </div>
              <div v-if="response === 'Sem acesso'" class="row col-12">
                <span class="col-12"
                  >Você precisa criar conta na Constr Pay para poder responder
                  essa cotação</span
                >
                <br />
                <button @click="redirectFor()" class="btn btn-success col-md-5">
                  Criar conta Constr Pay
                </button>
              </div>
              <div v-else class="btn-enviar" @click="enviarRespostaCotacao()">
                Responder Cotação
              </div>
            </div>
            <div class="position-relative p-10 text-left">
              <div class="row m-0">
                <div class="col-12 p-0">
                  <div class="form-group row m-0">
                    <label
                      for="cotacaoRespostaMotivo"
                      class="
                        col-sm-1 col-form-label
                        font-weight-bold
                        text-uppercase
                        fs-15
                        p-0
                        mt-3
                      "
                      >Motivos:</label
                    >
                    <br />
                    <div class="col-sm-12 mt-1 p-0">
                      <input
                        type="text"
                        :class="motivo.class"
                        id="cotacaoRespostaMotivo"
                        v-model="motivo.valor"
                        placeholder="Insira os motivos nesse campo caso vá rejeitar."
                      />
                    </div>
                  </div>
                </div>
                <div class="col-6 p-0 mt-3">
                  <div class="btn-rejeitar" @click="rejeitarCotacao()">
                    Rejeitar
                  </div>
                </div>
                <div class="col-6 p-0 mt-3 text-right">
                  <div class="btn-voltar" @click="voltarCotacao()">Voltar</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <b-modal
          ref="imagemZoom"
          id="imagemZoom"
          hide-footer
          title="Imagem selecionada!"
        >
          <div class="d-block text-center">
            <img
              class="obj-fill w-100 h-100"
              :src="`${getImagesAddress}` + imagemZoom"
              v-if="imagemZoom !== null"
            />
          </div>
        </b-modal>
      </div>
    </div>
    <b-modal
      id="comentarios"
      ref="comentarios"
      title="Comentarios"
      v-if="!checkIsEmpty(cotacao)"
      hide-footer
    >
      <template slot="modal-title">Dúvidas sobre esse produto</template>
      <div class="d-block text-center">
        <div class="limit_comentarios">
          <div class="comentarios_mensagens" v-if="tipoMenProd === 0">
            <div v-if="!checkIsEmpty(cotacao[0].produtos)">
              <div v-if="cotacao[0].produtos.length > 0">
                <div
                  class="row m-0"
                  v-for="(duvida, index) in cotacao[0].produtos[
                    mensagemProdutoAtual
                  ].duvidas"
                  :key="index"
                >
                  <div class="tipo col-3 p-0">
                    {{ dadosUsuario.tipo_usuario }}
                  </div>
                  <div class="mensagem col-9 p-0 text-left fs-14">
                    {{ duvida }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="comentarios_mensagens" v-else-if="tipoMenProd === 1">
            <div v-if="!checkIsEmpty(produtos)">
              <div v-if="produtos.length > 0">
                <div
                  class="row m-0"
                  v-for="(duvida, index) in produtos[mensagemProdutoAtual]
                    .duvidas"
                  :key="index"
                >
                  <div class="tipo col-3 p-0">
                    {{ dadosUsuario.tipo_usuario }}
                  </div>
                  <div class="mensagem col-9 p-0 text-left fs-14">
                    {{ duvida }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="caixa_texto_mensagem">
          <div class="row m-0">
            <div class="col-9 p-j-right-10px">
              <textarea
                class="caixa_texto fs-12"
                placeholder="Digite sua dúvida e clique em anexar!"
                v-model="mensagem"
              ></textarea>
            </div>
            <div class="col-3 p-j-left-10px">
              <div
                class="btn btn-envio-mensagem"
                v-if="this.tipoMenProd === 0"
                @click="anexarMensagem(mensagemProdutoAtual)"
              >
                Anexar
              </div>
              <div
                class="btn btn-envio-mensagem"
                v-else-if="this.tipoMenProd === 1"
                @click="anexarMensagemProd(mensagemProdutoAtual)"
              >
                Anexar
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-button class="mt-3" block @click="$bvModal.hide('comentarios')"
        >Fechar</b-button
      >
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import DownloadImages from '../../components/DownloadImages.vue';

export default {
  name: 'cotacao-resposta',
  components: {
    DownloadImages,
  },
  data: () => ({
    countDays: 14,
    tela: 0,
    response: [],
    items: [],
    errors: [],
    produtos: [],
    imagemZoom: null,
    motivo: {
      valor: null,
      mensagem: null,
      class: 'form-control',
    },
    frete: {
      valor: '0',
      mensagem: null,
      class: 'form-control frete-input',
    },
    prazo: {
      valor: '',
      mensagem: null,
      class: 'datepicker',
    },
    valor_total: {
      valor: null,
      mensagem: null,
      class: 'form-control valor-total-input',
    },
    codicoes: {
      valor: null,
      mensagem: null,
      class: 'form-control codicoes-input',
    },
    orcamentodata: {
      valor: null,
      mensagem: null,
      class: 'datepicker',
    },
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      suffix: '',
      precision: 2,
      masked: true,
    },
    tipoMenProd: 0,
    mensagemProdutoAtual: 0,
    mensagem: null,
    nome_vendedor: {
      value: '',
      class: 'form-control',
    },
    formaPagamento: '',
    boletoTotal: 0,
    pixTotal: 0,
    cartaoTotal: 0,
    totalParcelas: 0,
    cartaoParcelado: 0,
    pix: '',
    boleto: '',
    cartao: '',
    taxa: {
      cartao: 0,
      boleto: 0,
      pix: 0,
      upPix: 0,
      upBoleto: 0,
      upCartao: 0,
    },
    desconto: {
      pix: 0,
      boleto: 0,
      cartao: 0,
    },
    checked: false,
    pagamentos: {
      boleto: {
        pagamento: '',
        parcelas: null,
        desconto: null,
      },
      cartao: {
        pagamento: '',
        parcelas: null,
        desconto: null,
      },
      pix: {
        pagamento: '',
        parcelas: null,
        desconto: null,
      },
    },
  }),
  props: ['id'],

  beforeUpdate() {
    this.calcTax();
  },

  mounted() {
    this.showIugu();
    this.checkWindow();
  },
  created() {
    this.checkWindow();
    const self = this;

    if (this.checkIsEmpty(this.dadosUsuario)) {
      this.$router.push({ name: 'area-restrita' });
    }

    this.$store.dispatch('emptyCotacao').then(() => {
      this.$store.dispatch('startLoader');
      setTimeout(() => {
        self.$store
          .dispatch('showCotacao', this.id)
          .then(() => {
            setTimeout(() => {
              self.$store.dispatch('endLoader');
            }, 1000);
          })
          .catch(() => {
            setTimeout(() => {
              self.$store
                .dispatch('showCotacao', this.id)
                .then(() => {
                  setTimeout(() => {
                    self.$store.dispatch('endLoader');
                  }, 1000);
                })
                .catch(() => {
                  self.$store.dispatch('endLoader');
                  self.aviso(
                    'Não foi possível carregar as cotações! Tente novamente em 5 minutos!',
                    'danger'
                  );
                });
            }, 1000);
          });
      }, 1000);
    });

    this.$store.dispatch('loadProdutos');
    this.$store.dispatch('loadProdutoMarcas');
    this.$store.dispatch('loadTipoMedidas');
  },
  computed: {
    ...mapGetters('general', ['getImagesAddress']),
    ...mapGetters(['getTipoNotification', 'getNotification']),
    ...mapState({
      cotacao: (state) => state.cotacao,
      dadosUsuario: (state) => state.dadosUsuario,
      produtoMarcas: (state) => state.produtoMarcas,
      produtosRegistrados: (state) => state.produtos,
      tipoMedidas: (state) => state.tipoMedidas,
      valorTotal(state) {
        if (!this.checkIsEmpty(state.cotacao)) {
          if (state.cotacao.length > 0) {
            let valorTotal = 0;
            if (state.cotacao[0].produtos.length > 0) {
              for (const produto in state.cotacao[0].produtos) {
                let valorString = String(
                  state.cotacao[0].produtos[produto].preco
                );
                if (state.cotacao[0].produtos[produto].disponivel === true) {
                  valorString = parseFloat(valorString.replace(/[\D]+/g, ''));
                  valorTotal +=
                    parseFloat(valorString) *
                    parseFloat(state.cotacao[0].produtos[produto].quantidade);
                }
              }
            }
            if (this.produtos.length > 0) {
              for (const produto in this.produtos) {
                let valorString = String(this.produtos[produto].preco);
                valorString = parseFloat(valorString.replace(/[\D]+/g, ''));
                if (this.produtos[produto].quantidade === null) {
                  valorTotal += parseFloat(valorString) * parseFloat(0);
                } else {
                  valorTotal +=
                    parseFloat(valorString) *
                    parseFloat(this.produtos[produto].quantidade);
                }
              }
            }
            return valorTotal;
          }
          return 0;
        }
      },
    }),
    freteValor() {
      const freteString = parseFloat(this.frete.valor.replace(/[\D]+/g, ''));
      return freteString;
    },
    preferencia() {
      if (!this.checkIsEmpty(this.cotacao)) {
        const pref = this.cotacao[0].preferencia;
        if (pref === 1) {
          return 'Menor Preço';
        }
        if (pref === 2) {
          return 'Custo-Benefício';
        }
        if (pref === 3) {
          return 'Melhor Marca';
        }
      }
      return 'Sem Informação';
    },
  },

  methods: {
    calcTax() {
      let totalBruto = this.valorTotal / 100;
      let construTaxa = 0.040;
      let descontoPix = totalBruto * (this.desconto.pix / 100);
      let pixComDesconto = totalBruto - descontoPix;
      this.pixTotal = pixComDesconto - pixComDesconto * 0.0099 - 0.3;
      this.taxa.upPix = pixComDesconto * construTaxa;
      this.pixTotal = this.pixTotal - this.taxa.upPix;
      this.taxa.pix = pixComDesconto * 0.0099 + 0.3;
      this.pixTotal = this.pixTotal.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
      this.taxa.pix = this.taxa.pix.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
      this.taxa.upPix = this.taxa.upPix.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });

      let descontoBoleto = totalBruto * (this.desconto.boleto / 100);
      let boletoComDesconto = totalBruto - descontoBoleto;
      this.boletoTotal = boletoComDesconto - boletoComDesconto * 0.015 - 0.3;
      this.taxa.upBoleto = boletoComDesconto * construTaxa;
      this.boletoTotal = this.boletoTotal - this.taxa.upBoleto;
      this.taxa.boleto = boletoComDesconto * 0.015 + 0.3;
      this.boletoTotal = this.boletoTotal.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
      this.taxa.boleto = this.taxa.boleto.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
      this.taxa.upBoleto = this.taxa.upBoleto.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });

      let taxaCartao = 0.0235;
      let totalParcial = totalBruto - totalBruto * taxaCartao - 0.3;
      this.cartaoTotal = totalParcial - totalBruto * construTaxa;
      this.taxa.cartao = totalBruto * taxaCartao + 0.3;
      this.taxa.upCartao = totalBruto * construTaxa;
      this.cartaoParcelado = this.cartaoTotal / this.totalParcelas;
      this.cartaoTotal = this.cartaoTotal.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
      this.taxa.cartao = this.taxa.cartao.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
      this.taxa.upCartao = this.taxa.upCartao.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
      this.cartaoParcelado = this.cartaoParcelado.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    },
    selectQtdParcelas(type = '') {
      if(this.totalParcelas > 0 && this.cartao == '' && type == 'prod') {
        this.cartao = 'C'
        let checkboxCartao = document.getElementById('checkboxCartao');
        checkboxCartao.checked = true;
      }
    },
    formPayments(value) {
      let checkboxPix = document.getElementById('checkboxPix');
      let checkboxBoleto = document.getElementById('checkboxBoleto');
      let checkboxCartao = document.getElementById('checkboxCartao');

      if (value === 'P') {
        if (checkboxPix.checked) {
          this.pix = 'P';
        } else {
          this.pix = '';
        }
      }

      if (value === 'B') {
        if (checkboxBoleto.checked) {
          this.boleto = 'B';
        } else {
          this.boleto = '';
        }
      }

      if (value === 'C') {
        if (checkboxCartao.checked) {
          if(this.totalParcelas == 0){
            this.totalParcelas = 1;
          }
          this.cartao = 'C';
        } else {
          this.cartao = '';
          this.totalParcelas = 0;
        }
      }
    },

    checkWindow() {
      this.tela = window.innerWidth;
    },

    redirectFor() {
      this.$router.push({
        name: 'lojista-iugu-update',
      });
    },

    showIugu() {
      this.$store
        .dispatch('showInfoDashboard' )
        .then((resp) => {})
        .catch((error) => {
          if (error.response.status === 500) {
            this.response = 'Sem acesso';
          }
        });
    },
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    voltarCotacao() {
      this.$router.push({
        name: 'lojista-recebidas',
      });
    },
    retirarAvisos() {
      this.errors = [];
      this.motivo.class = 'form-control';
      this.frete.class = 'form-control frete-input';
      this.prazo.class = 'datepicker';
      this.valor_total.class = 'form-control valor-total-input';
      this.codicoes.class = 'form-control codicoes-input';
      this.orcamentodata.class = 'datepicker';
      this.nome_vendedor.class = 'form-control';
    },
    enviarRespostaCotacao() {
      this.retirarAvisos();
      if (this.checkIsEmpty(this.freteValor)) {
        this.frete.class += ' error-form';
        this.errors.push('o frete');
      }

      if (this.checkIsEmpty(this.valorTotal)) {
        this.valor_total.class += ' error-form';
         this.errors.push('o valor total');
      }

      if (this.checkIsEmpty(this.pix) && this.checkIsEmpty(this.boleto) && this.checkIsEmpty(this.cartao)) {
        this.errors.push('as condições de pagamento');
      }
      
      // MOSTRAR MSG DE ERRO QTO  A PARCELA ESTIVER ZERADA
      // IR PARA LINHA 1738
      if(!this.checkIsEmpty(this.cartao) && this.totalParcelas == 0){
        this.errors.push('o numero de parcelas')
      }

      if (this.checkIsEmpty(this.orcamentodata.valor)) {
        this.orcamentodata.class += ' error-form';
        this.errors.push('a data de orçamento valido');
      }

      if (this.checkIsEmpty(this.nome_vendedor.value)) {
        this.nome_vendedor.class += ' error-form';
        this.errors.push('nome do vendedor(a)');
      }

      if (this.checkIsEmpty(this.prazo.valor)) {
        this.prazo.class += ' error-form';
        this.errors.push('prazo de entrega');
      }

      if (this.errors.length === 0) {
        const produtosAlt = [];
        let messageProd = null;

        if (this.cotacao[0].produtos.length > 0) {
          for (const produto in this.cotacao[0].produtos) {
            this.cotacao[0].produtos[produto].precoAlt = this.unsMaskValor(
              this.cotacao[0].produtos[produto].preco
            );
            produtosAlt.push(this.cotacao[0].produtos[produto]);
          }
        }

        if (this.produtos.length > 0) {
          for (const produto in this.produtos) {
            this.produtos[produto].precoAlt = this.unsMaskValor(
              this.produtos[produto].preco
            );
            this.produtos[produto].disponivel = true;
            if (
              this.produtos[produto].nome === null &&
              this.produtos[produto].produto === null
            ) {
              messageProd = 'Existem produtos vazios';
            }
            produtosAlt.push(this.produtos[produto]);
          }
        }

        if (this.boleto != '') {
          this.pagamentos.boleto.pagamento = this.boleto;
          this.pagamentos.boleto.desconto = this.desconto.boleto;
          this.pagamentos.boleto.parcelas = 1;
        }
        if (this.pix != '') {
          this.pagamentos.pix.pagamento = this.pix;
          this.pagamentos.pix.desconto = this.desconto.pix;
          this.pagamentos.pix.parcelas = 1;
        }
        if (this.cartao != '') {
          this.pagamentos.cartao.pagamento = this.cartao;
          this.pagamentos.cartao.desconto = 0;
          this.pagamentos.cartao.parcelas = this.totalParcelas;
        }

        if (messageProd === null) {
          const dadosResposta = {
            cotacao_id: this.cotacao[0].id,
            usuario_enviador_id: this.dadosUsuario.id,
            usuario_recebedor_id: this.cotacao[0].usuario.usuario_id,
            produtos: produtosAlt,
            pagamentos: this.pagamentos,
            valor_total: this.valorTotal + this.freteValor,
            frete: this.freteValor,
            prazo: this.prazo.valor,
            validade: this.orcamentodata.valor,
            arquivo: this.cotacao[0].arquivo,
            imagem: this.cotacao[0].imagem,
            quantidade_arquivo: this.cotacao[0].quantidade_arquivo,
            quantidade_foto: this.cotacao[0].quantidade_foto,
            nome_vendedor: this.nome_vendedor.value,
          };

          // this.$store.dispatch('startLoader');
          this.$store
            .dispatch('insertCotacaoResposta', dadosResposta)
            .then(() => {
              setTimeout(() => {
                this.$store.dispatch('endLoader');
                this.aviso('A cotação foi respondida com sucesso!', 'success');
                setTimeout(() => {
                  this.$router.push({ name: 'lojista-recebidas' });
                }, 1000);
              }, 1500);
            })
            .catch(() => {
              this.$store.dispatch('endLoader');
              this.aviso(
                'Não foi possível responder a cotação! Tente novamente em 5 minutos!',
                'danger'
              );
            });
        } else {
          this.$store.dispatch('endLoader');
          this.aviso(messageProd, 'danger');
        }
      } else {
        this.$store.dispatch('endLoader');
        for (const erro in this.errors) {
          this.aviso(
            `É necessário colocar '${this.errors[erro]}' para enviar a resposta`,
            'warning'
          );
        }
      }
    },
    rejeitarCotacao() {
      if (confirm('Deseja realmente rejeitar essa cotação ?')) {
        if (this.motivo.valor === null) {
          this.aviso(
            'É necessário escrever o motivo para rejeitar essa cotação!',
            'warning'
          );
        } else {
          const dadosResposta = {
            cotacao_id: this.cotacao[0].id,
            usuario_enviador_id: this.dadosUsuario.id,
            usuario_recebedor_id: this.cotacao[0].usuario.usuario_id,
            parcelas: this.totalParcelas,
            desconto_pix: this.desconto.pix,
            boleto: this.boleto,
            pix: this.pix,
            cartao: this.cartao,
            desconto_boleto: this.desconto.boleto,
            valor_total: this.valorTotal + this.freteValor,
            frete: this.freteValor,
            prazo: this.prazo.valor,
            validade: this.orcamentodata.valor,
            arquivo: this.cotacao[0].arquivo,
            imagem: this.cotacao[0].imagem,
            quantidade_arquivo: this.cotacao[0].quantidade_arquivo,
            quantidade_foto: this.cotacao[0].quantidade_foto,
            motivo_rejeicao: this.motivo.valor,
          };

          this.$store
            .dispatch('insertCotacaoRespostaRejeitada', dadosResposta)
            .then((data) => {
              setTimeout(() => {
                if (this.getTipoNotification == 1) {
                  this.aviso(this.getNotification, 'success');
                  this.$router.push({
                    name: 'lojista-rejeitadas-pelo-usuario',
                  });
                } else if (this.getTipoNotification == 3) {
                  this.aviso(this.getNotification, 'danger');
                }
              }, 1000);
            });
        }
      }
    },
    unsMaskValor(valor) {
      return parseInt(String(valor).replace(/[\D]+/g, ''));
    },
    subValor(valor, quantidade) {
      let valorString = String(valor);
      if (quantidade === null) {
        valorString = parseInt(valorString.replace(/[\D]+/g, '')) * parseInt(0);
      } else {
        valorString =
          parseInt(valorString.replace(/[\D]+/g, '')) * parseInt(quantidade);
      }
      return valorString;
    },
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    adicionarProduto() {
      this.produtos.push({
        produto_nome: null,
        marca_nome: null,
        medida_nome: null,
        quantidade: null,
        preco: null,
        produto: null,
        marca: null,
        medida: null,
        tipo_obj: true,
        marca_obj: true,
        medida_obj: true,
        duvidas: [],
      });
    },
    showZoom(data) {
      this.imagemZoom = data;
      this.$bvModal.show('imagemZoom');
    },
    apagarProduto(index) {
      this.produtos.splice(index, 1);
    },
    abrirCaixa(index) {
      this.tipoMenProd = 0;
      this.mensagem = null;
      this.mensagemProdutoAtual = index;
      this.$bvModal.show('comentarios');
    },
    abrirCaixaProd(index) {
      this.tipoMenProd = 1;
      this.mensagem = null;
      this.mensagemProdutoAtual = index;
      this.$bvModal.show('comentarios');
    },
    anexarMensagem(index) {
      if (!this.checkIsEmpty(this.mensagem)) {
        this.cotacao[0].produtos[index].duvidas.push(this.mensagem);
        this.aviso('Sua dúvida foi anexada com sucesso!', 'success');
      }
    },
    anexarMensagemProd(index) {
      if (!this.checkIsEmpty(this.mensagem)) {
        this.produtos[index].duvidas.push(this.mensagem);
        this.aviso('Sua dúvida foi anexada com sucesso!', 'success');
      }
    },
    // função para remover caracteres especiais do input de preço unitário
    removeSpecialChars(e) {
      if (/^\W$/.test(e.key)) {
        e.preventDefault();
      }
    },
    // função para bloquear datas retroatiovas Orçamento
    blockPreviousDates() {
      const agora = new Date();
      const escolhida = new Date(this.orcamentodata.valor);
      if (escolhida < agora)
        this.orcamentodata.valor = [
          agora.getFullYear(),
          agora.getMonth() + 1,
          agora.getDate(),
        ]
          .map((v) => (v < 10 ? `0${v}` : v))
          .join('-');
    },
    // função para bloquear datas retroatiovas Entrega
    blockPreviousDatesDelivery() {
      const agora = new Date();
      const escolhida = new Date(this.prazo.valor);
      if (escolhida < agora)
        this.prazo.valor = [
          agora.getFullYear(),
          agora.getMonth() + 1,
          agora.getDate(),
        ]
          .map((v) => (v < 10 ? `0${v}` : v))
          .join('-');
    },
  },
};
</script>

<style>
@import '../../custom/css/cotacao.css';

.cotation-actions {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex: 0 0 33%;
}

.resize-input {
  width: 90%;
}

.size-font {
  font-size: 16px;
}

.alinhamento {
  -webkit-box-shadow: 2px 2px 1px rgba(0, 0, 0, 0.1);
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);
  border: 1px solid rgb(0, 0, 0, 0.1);
  border-radius: 5px;
  width: 80%;
}

.header-table {
  border-style: solid;
  border-color: rgb(212, 205, 205);
  border-width: 1px 0 1px 0;
  background-color: #f8f9fa;
}
.hideselect {
  -webkit-appearance: none;
  margin: 0;
  -moz-appearance: textfield;
}
.freteMargin {
  margin: 0 !important;
}
</style>